<template>
  <div class="modal fade" id="productoModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-navy">
          <h5 class="modal-title">
            <span v-if="isEditing && producto?.descripcion">
              <i class="fas fa-edit mr-2"></i>Editar: {{ producto.descripcion }}
            </span>
            <span v-else>
              <i class="fas fa-plus-circle mr-2"></i>Agregar Nuevo Producto
            </span>
          </h5>
          <button type="button" class="close text-white" data-dismiss="modal">&times;</button>
        </div>
        
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-md-6 border-right">
                <h6 class="text-navy mb-3"><strong><i class="fas fa-fingerprint"></i> Identidad</strong></h6>
                
                <div class="form-group">
                  <label>Código del Producto</label>
                  <input v-model="form.codigo" type="text" class="form-control text-uppercase" 
                    :class="{'is-invalid': errors.codigo}" :disabled="isEditing" placeholder="EJ: HAR-001" />
                  <div class="invalid-feedback">{{ errors.codigo }}</div>
                </div>

                <div class="form-group">
                  <label>Categoría</label>
                  <select v-model="form.categoria_id" class="form-control" 
                    :class="{'is-invalid': errors.categoria_id}" :disabled="isEditing">
                    <option value="" disabled>Seleccione una categoría</option>
                    <option v-for="cat in categorias.filter(c => c.proveedor?.estatus != 0)" :key="cat.id" :value="cat.id">
                      {{ cat.descripcion }} ({{ cat.proveedor?.descripcion }})
                    </option>
                  </select>
                  <div class="invalid-feedback">{{ errors.categoria_id }}</div>
                </div>

                <div class="form-group">
                  <label>Descripción / Nombre Comercial</label>
                  <input v-model="form.descripcion" type="text" class="form-control text-uppercase" 
                    :class="{'is-invalid': errors.descripcion}" :disabled="isEditing" placeholder="EJ: HARINA DE MAÍZ 1KG" />
                  <div class="invalid-feedback">{{ errors.descripcion }}</div>
                </div>

                <div class="form-group">
                  <label>Cant. x Caja</label>
                  <input v-model.number="form.cantxcaja" type="number" class="form-control" 
                    :disabled="isEditing" min="1" />
                </div>
              </div>

              <div class="col-md-6">
                <h6 class="text-navy mb-3"><strong><i class="fas fa-money-bill-wave"></i> Precios y Empaque</strong></h6>
                
                <div class="row">
                  <div class="form-group col-6">
                    <label>Precio Unit. (Base)</label>
                    <input type="text" :value="form.precunid" 
                      @input="formatPrice($event, 'precunid')" @keypress="onlyNumbers"
                      class="form-control font-weight-bold text-success" placeholder="0.00" />
                  </div>
                  
                  <div class="form-group col-6">
                    <label>IVA Aplicado ($)</label>
                    <input type="text" :value="form.porciva" 
                      @input="formatPrice($event, 'porciva')" @keypress="onlyNumbers"
                      class="form-control" placeholder="0.00" />
                  </div>

                  <div class="form-group col-6">
                    <label>Unit. (Con IVA)</label>
                    <input :value="precioConIva" class="form-control bg-light font-weight-bold" readonly />
                  </div>

                  <div class="form-group col-6">
                    <label>Precio por Caja</label>
                    <div class="input-group">
                      <input :value="form.preccaja" readonly
                        class="form-control font-weight-bold bg-light" />
                    </div>
                  </div>

                  <div class="form-group col-6">
                    <label>PVP Sugerido (Ref)</label>
                    <input type="text" :value="form.ref" 
                      @input="formatPrice($event, 'ref')" @keypress="onlyNumbers"
                      class="form-control" placeholder="0.00" />
                    <small class="text-muted">Precio sugerido de venta</small>
                  </div>

                  <div class="form-group col-6">
                    <label>Venta por</label>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" v-model="form.vende_unidad" class="custom-control-input" id="vUnit">
                      <label class="custom-control-label" for="vUnit">Unidades</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" v-model="form.vende_caja" class="custom-control-input" id="vCaja">
                      <label class="custom-control-label" for="vCaja">Cajas</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3 border-top pt-3" v-if="isEditing">
              <div class="col-12">
                <div class="custom-control custom-switch">
                  <input type="checkbox" v-model="form.estatus" class="custom-control-input" id="swProd">
                  <label class="custom-control-label" for="swProd">
                    <span :class="form.estatus ? 'text-success' : 'text-danger'">
                      {{ form.estatus ? 'PRODUCTO ACTIVO' : 'PRODUCTO INACTIVO' }}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div class="modal-footer px-0 pb-0 mt-4">
              <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
              <button type="submit" class="btn btn-navy shadow px-4">
                <i class="fas fa-save mr-1"></i> {{ isEditing ? "Actualizar Precios" : "Guardar Producto" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { alert } from "@/plugins/alert.js";
import { loading } from "@/plugins/loading.js";

export default {
  props: ["producto", "categorias"],
  data() {
    return {
      form: this.getDefaultForm(),
      errors: {}
    };
  },
  computed: {
    isEditing() { 
      return !!(this.producto && this.producto.id); 
    },
    precioConIva() {
      const base = parseFloat(this.form.precunid || 0);
      const iva = parseFloat(this.form.porciva || 0);
      return (base + iva).toFixed(2);
    }
  },
  watch: {
    producto: {
      immediate: true,
      handler(newVal) {
        this.errors = {};
        if (newVal && newVal.id) {
          this.form = { 
            ...newVal, 
            estatus: Boolean(newVal.estatus),
            // Aseguramos formato decimal para el formulario
            precunid: parseFloat(newVal.precunid).toFixed(2),
            preccaja: parseFloat(newVal.preccaja || 0).toFixed(2),
            porciva: parseFloat(newVal.porciva || 0).toFixed(2),
            ref: parseFloat(newVal.ref || 0).toFixed(2),
            vende_unidad: Boolean(newVal.vende_unidad),
            vende_caja: Boolean(newVal.vende_caja)

          };
        } else {
          this.form = this.getDefaultForm();
        }
      }
    },
    // Observadores para el cálculo automático de la caja al crear
    'form.precunid': function() { this.autoCalcularCaja(); },
    'form.cantxcaja': function() { this.autoCalcularCaja(); },
    'form.porciva': function() { this.autoCalcularCaja(); }
  },
  methods: {
    getDefaultForm() {
      return {
        codigo: "", descripcion: "", precunid: "0.00", preccaja: "0.00", ref: "0.00",
        cantxcaja: 1, porciva: "0.00", categoria_id: "",
        vende_unidad: true, vende_caja: false, estatus: true
      };
    },
    onlyNumbers(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    formatPrice(e, field) {
      // Eliminar todo lo que no sea número
      let rawValue = e.target.value.replace(/\D/g, "");
      // Convertir a decimal (centavos) y asegurar que siempre sea al menos 0.00
      this.form[field] = (parseInt(rawValue || 0) / 100).toFixed(2);
    },
    autoCalcularCaja() {
      // El cálculo ahora es siempre automático y el campo es readonly
      const unitario = parseFloat(this.form.precunid || 0);
      const iva = parseFloat(this.form.porciva || 0);
      const total = ((unitario + iva) * parseInt(this.form.cantxcaja || 0)).toFixed(2);
      this.form.preccaja = total;
    },
    async submitForm() {
      this.errors = {};
      try {
        loading.show('Procesando catálogo...');
        
        // El payload se adapta a lo que el controlador permite en el UPDATE
        const payload = this.isEditing 
          ? { 
              precunid: this.form.precunid, 
              preccaja: this.form.preccaja,
              ref: this.form.ref,
              porciva: this.form.porciva,
              vende_unidad: this.form.vende_unidad,
              vende_caja: this.form.vende_caja,
              estatus: this.form.estatus 
            }
          : { 
              ...this.form, 
              codigo: this.form.codigo.trim().toUpperCase(), 
              descripcion: this.form.descripcion.trim().toUpperCase() 
            };

        if (this.isEditing) {
          await api.put(`/producto/${this.producto.id}`, payload);
        } else {
          await api.post("/producto", payload);
        }

        loading.hide();
        alert.toast({ title: '¡Operación exitosa!', icon: 'success' });
        this.$emit("success");
        window.$("#productoModal").modal("hide");

      } catch (error) {
        loading.hide();
        console.error("Error en Producto:", error);

        const data = error.response?.data;
        const status = error.response?.status;

        // Captura de mensajes del backend (Stock > 0, Integridad, etc.)
        let titulo = data?.message || 'Error al guardar';
        let detalle = data?.detalles || '';

        // Si es error de validación de Laravel, buscamos el primer error real
        if (status === 422 && data.errors) {
          this.errors = data.errors;
          if (titulo === "The given data was invalid.") {
            const firstKey = Object.keys(data.errors)[0];
            titulo = data.errors[firstKey][0];
          }
        }

        alert.toast({ 
          title: titulo, 
          text: detalle, 
          icon: status === 403 ? 'warning' : 'error', 
          timer: 6000 
        });
      }
    }
  }
};
</script>

<style scoped>
.modal-body { max-height: 75vh; overflow-y: auto; }
.btn-navy { background-color: #001f3f; color: white; }
.btn-navy:hover { background-color: #00132a; color: white; }
.text-navy { color: #001f3f; }
</style>